import { createReducer } from '@reduxjs/toolkit';

import { hideSidebar, showSidebar, toggleSidebar } from './actions';

const sidebarReducer = createReducer(true, (builder) => {
  builder
    .addCase(hideSidebar, () => false)
    .addCase(showSidebar, () => true)
    .addCase(toggleSidebar, (state, action) => action.payload);
});

export default sidebarReducer;
